export default "__VITE_ASSET__C1zVKx0V__"